import React from 'react';

import { SkeletonImage } from '@xingternal/skeleton';
import {
  useEditContext,
  usePageContext,
  EmployerBrandingFlag,
} from '@xingternal/pages-common';
import * as Types from '@xingternal/pages-graphql-types';

import CoverMedia from './CoverMedia';
import { useXingFrame } from '../../../src/hooks';
import type {
  EntityPageCoverImageQueryResult,
  CoverImageFragment,
} from './CoverImageQuery.gql-types';

import { EditCover } from '../Edit/Images';

import styles from './CoverMedia.css';

export const ENTITY_PAGES_UNFENCE_HEADER: string =
  'entity_pages_unfence_header';

export interface CoverMediaImagesUrlType {
  [reference: string]: any;
}
const getImagesUrl = (
  coverData: CoverImageFragment[]
): CoverMediaImagesUrlType =>
  coverData.reduce(
    (obj, item) => Object.assign(obj, { [String(item.reference!)]: item.url }),
    {}
  );

type CoverMediaContainerProps = {
  isPageLoading?: boolean;
  canBeEdited?: boolean;
  isFreePage?: boolean;
  coverMediaQueryResult?: EntityPageCoverImageQueryResult;
};
const CoverMediaContainer: React.FC<CoverMediaContainerProps> = ({
  isPageLoading,
  isFreePage,
  coverMediaQueryResult,
}) => {
  const { isEditing } = useEditContext();
  const { pageContext } = usePageContext();
  const { featureSwitches } = useXingFrame();

  const newCover = pageContext?.coverMedia?.newCover;
  const newOriginalCover = pageContext?.coverMedia?.newOriginalCover;

  const { data, loading, refetch } = coverMediaQueryResult || {};

  const coverMediaData =
    data?.entityPageEX?.__typename === 'EntityPage'
      ? data?.entityPageEX?.coverImage
      : undefined;

  const hasFenceFS = featureSwitches.includes(ENTITY_PAGES_UNFENCE_HEADER);
  const isFreeHeaderProfile =
    hasFenceFS &&
    isFreePage &&
    pageContext.focusType === Types.EntityPageFocusType.Company;

  if ((!hasFenceFS && isFreePage) || (isFreeHeaderProfile && !isEditing)) {
    return <CoverMedia />;
  }

  if (isPageLoading || loading || !data) {
    return (
      <div className={styles.coverImageWrapper}>
        <SkeletonImage variant="secondary" className={styles.coverImageInner} />
      </div>
    );
  }

  return (
    <>
      <CoverMedia
        data={coverMediaData ? getImagesUrl(coverMediaData) : null}
        newCover={newCover}
      />
      {isEditing && !loading && (
        <span className={styles.editingWrapperCover}>
          {isFreeHeaderProfile && (
            <EmployerBrandingFlag hasImage={!!coverMediaData || !!newCover} />
          )}
          <EditCover
            newOriginalCover={newOriginalCover}
            hasCover={!!coverMediaData || !!newCover}
            isFreePage={isFreePage}
            refetchCover={refetch}
          />
        </span>
      )}
    </>
  );
};

export default CoverMediaContainer;
